import {useRef, useEffect, useState} from "react";
import ThumbnailItem from "../thumbnailItem";
import {ThumbnailContainerProps} from "./thumbnailContainer.props";
import {ThumbNailServiceContainer} from "./thumbnailContainer.styled";

const ThumbnailContainer: React.FC<ThumbnailContainerProps> = ({
  bodyContent,
  data,
  isService,
  onchangeService,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number | null>(null);

  useEffect(() => {
    if (containerRef.current) {
      setWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [data]);

  const sortedData = data?.slice().sort((a, b) => {
    const nameA = a.mainServiceName?.toLowerCase() || "";
    const nameB = b.mainServiceName?.toLowerCase() || "";
    return nameA.localeCompare(nameB);
  });
  return (
    <>
      {data && data.length > 0 ? (
        <>
          <ThumbNailServiceContainer
            ref={containerRef}
            className="mr-[-10px]"
          >
            {sortedData?.map((item, index) => (
              <ThumbnailItem
                key={index}
                bodyContent={bodyContent}
                data={item}
                isService={isService}
                buttonText="View"
                onchangeSelectedService={(e) => {
                  onchangeService(e);
                }}
                buttonTextClassName="serviceBtnItem"
                width={(Number(width) / 3 - 20)}
              />
            ))}
          </ThumbNailServiceContainer>
        </>
      ) : null}
    </>
  );
};

export default ThumbnailContainer;
